import { use } from 'react';
import CartContext from '../cart.context';
const useCartFormEmail = () => {
    const { email, setEmail, emailError, setIsEmailInError } = use(CartContext);
    return { email, setEmail, emailError, setIsEmailInError };
};
export default useCartFormEmail;
